export const isNotUndefined = <P>(item: P | undefined): item is P => {
    return Boolean(item !== undefined);
};

export const isStringArray = <I>(
    items: Array<I> | string[],
): items is string[] => {
    return Boolean(typeof items[0] === 'string');
};
